<template>
  <component
    :is="comingSoon ? 'div' : 'b-link'"
    :to="comingSoon ? undefined : to"
    :aria-disabled="comingSoon ? 'true' : undefined"
    class="landing-card-link"
    :class="{ 'landing-card-link--inactive': comingSoon }"
  >
    <article class="landing-card">
      <div class="landing-card__glow"></div>
      <div class="landing-card__content">
        <div class="landing-card__icon">
          <slot name="image"></slot>
        </div>

        <div class="landing-card__copy">
          <h3 class="landing-card__title">
            <slot name="paragraph"></slot>
          </h3>
          <p class="landing-card__subtitle">
            <slot name="subtitle"></slot>
          </p>
          <div class="landing-card__actions">
            <span v-if="comingSoon" class="landing-card__status">Coming soon</span>
            <slot v-else name="subtitle2"></slot>
          </div>
        </div>
      </div>
    </article>
  </component>
</template>

<script>
export default {
  name: 'Cards',
  props: {
    comingSoon: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.landing-card-link {
  display: block;
  height: 100%;
  text-decoration: none;
}

.landing-card {
  position: relative;
  height: 100%;
  min-height: 22rem;
  overflow: hidden;
  border: 1px solid rgba(24, 57, 31, 0.08);
  border-radius: 28px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.94), rgba(245, 250, 246, 0.96)), #ffffff;
  box-shadow: 0 20px 45px rgba(20, 55, 31, 0.07), inset 0 1px 0 rgba(255, 255, 255, 0.72);
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.landing-card-link:not(.landing-card-link--inactive) .landing-card:hover {
  transform: translateY(-4px);
  border-color: rgba(48, 171, 76, 0.18);
  box-shadow: 0 28px 55px rgba(20, 55, 31, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.72);
}

.landing-card__glow {
  position: absolute;
  top: -10%;
  right: -10%;
  width: 10rem;
  height: 10rem;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(48, 171, 76, 0.16), transparent 68%);
}

.landing-card__content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1.5rem;
}

.landing-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  margin-bottom: 1.35rem;
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(238, 247, 240, 0.96), rgba(255, 255, 255, 0.95));
  border: 1px solid rgba(48, 171, 76, 0.12);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.78);
}

.landing-card__copy {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.landing-card__title {
  margin: 0 0 0.85rem;
  color: #183322;
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.3;
}

.landing-card__subtitle {
  margin: 0;
  color: #567063;
  line-height: 1.7;
}

.landing-card__actions {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin-top: auto;
  padding-top: 1.3rem;
  color: #2a8a43;
}

.landing-card__actions ::v-deep a,
.landing-card__actions ::v-deep button {
  color: #2a8a43 !important;
  text-decoration: none !important;
  font-weight: 700;
}

.landing-card__actions ::v-deep a:hover,
.landing-card__actions ::v-deep button:hover {
  color: #1f6f33 !important;
}
.landing-card-link--inactive .landing-card {
  background: #f5f7f5;
  box-shadow: none;
}
.landing-card-link--inactive .landing-card__glow {
  display: none;
}
.landing-card-link--inactive .landing-card__icon {
  filter: grayscale(1);
  opacity: 0.65;
}
.landing-card-link--inactive .landing-card__title {
  color: #58685e;
}
.landing-card__status {
  align-self: flex-start;
  padding: 0.4rem 0.7rem;
  border: 1px solid #dce3dd;
  border-radius: 7px;
  background: #eaf0eb;
  color: #637268;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.03em;
}
</style>
